import React from 'react';
import { useSelector } from 'react-redux';
import { getUserMeta } from 'shared/config/store/reducers/userSlice';
import { Button, Flex, Typography } from 'antd';
import { ExclamationOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { RoundContainer } from 'shared/ui';
import { useGetCountriesQuery } from 'entities/countries/api';
import { getFormattedAddress } from 'entities/countries/model/utils';
import { COLORS } from 'shared/const/theme';

const Info: React.FC<{ onSubmit: () => unknown }> = ({ onSubmit }) => {
    const userMeta = useSelector(getUserMeta);
    const { formatMessage: t } = useIntl();
    const { data: countriesResponse } = useGetCountriesQuery();
    const countries = countriesResponse?.response ?? [];
    const fullAddress = getFormattedAddress(userMeta.address, countries);

    return (
        <Flex vertical gap={16} style={{ padding: '24px 0' }}>
            <Flex vertical align="center" gap={16}>
                <RoundContainer size={64} color={COLORS.WARNING}>
                    <ExclamationOutlined style={{ color: '#fff', fontSize: 32 }} />
                </RoundContainer>
                <Typography.Text
                    style={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                        fontSize: 18,
                        marginBottom: 8,
                    }}
                >
                    {t({id: 'card.getPlastic.label.checkAddress'})}
                </Typography.Text>
                <Typography.Text style={{ textAlign: 'center', marginBottom: 8 }}>
                    {t({id: 'card.getPlastic.label.address'})}
                </Typography.Text>
                <Typography.Text style={{ fontWeight: 'bold', marginBottom: 24, marginTop: 8, textAlign: 'center' }}>
                    {fullAddress}
                </Typography.Text>
                <Typography.Text style={{ fontSize: 14, textAlign: 'center' }}>
                    {t({id: 'card.getPlastic.label.support.1'})}{' '}
                    <Typography.Link
                        href='mailto:cardservice@weststeincard.com'
                        style={{
                            fontWeight: 'bold',
                            textDecorationLine: 'underline',
                            marginInline: 4,
                        }}>
                        cardservice@weststeincard.com
                    </Typography.Link>{' '}
                    {t({id: 'card.getPlastic.label.support.2'})}
                </Typography.Text>
            </Flex>
            <Button onClick={onSubmit} type="primary" block style={{ marginTop: 8 }}>
                {t({ id: 'buttons.continue'})}
            </Button>
        </Flex>
    );
};

export default Info;
